import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}
export function SEO({
  title = 'Comunicación Magnética - Pack Premium de 7 Ebooks | $9.95',
  description = 'Aprende a hablar con autoridad y convencer sin rogar. Pack completo de 7 ebooks digitales por solo $9.95. Descarga inmediata. Sistema IMÁN incluido.',
  keywords = 'comunicación magnética, ebooks comunicación, hablar en público, liderazgo, ventas, presencia digital, autoridad, sistema IMÁN, comunicación efectiva, oratoria, curso de oratoria, lenguaje corporal',
  image = 'https://cdn.magicpatterns.com/uploads/3roP78wC5T4ePwrj5adkFD/portada_libro_principal.png',
  url = 'https://mikioscodigital.com'
}: SEOProps) {
  const siteTitle = title;
  const siteDescription = description;
  const siteUrl = url;
  const siteImage = image;
  // JSON-LD Structured Data for Product
  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Comunicación Magnética - Pack Premium',
    image: ['https://cdn.magicpatterns.com/uploads/3roP78wC5T4ePwrj5adkFD/portada_libro_principal.png', 'https://cdn.magicpatterns.com/uploads/hb4aF6X3XuCrATJ36jaKtR/collage_7_libros.png'],
    description: 'Pack completo de 7 ebooks para dominar la comunicación, presencia y autoridad. Incluye el libro principal y 6 bonos exclusivos.',
    brand: {
      '@type': 'Brand',
      name: 'Comunicación Magnética'
    },
    offers: {
      '@type': 'Offer',
      url: 'https://mikioscodigital.com/cart/51802866975001:1',
      priceCurrency: 'USD',
      price: '9.95',
      priceValidUntil: '2025-12-31',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '1250'
    }
  };
  return <Helmet data-id="element-440">
      {/* Standard Meta Tags */}
      <html lang="es" data-id="element-441" />
      <title data-id="element-442">{siteTitle}</title>
      <meta name="description" content={siteDescription} data-id="element-443" />
      <meta name="keywords" content={keywords} data-id="element-444" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" data-id="element-445" />
      <meta charSet="utf-8" data-id="element-446" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" data-id="element-447" />
      <link rel="canonical" href={siteUrl} data-id="element-448" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-449" />
      <meta property="og:url" content={siteUrl} data-id="element-450" />
      <meta property="og:title" content={siteTitle} data-id="element-451" />
      <meta property="og:description" content={siteDescription} data-id="element-452" />
      <meta property="og:image" content={siteImage} data-id="element-453" />
      <meta property="og:locale" content="es_ES" data-id="element-454" />
      <meta property="og:site_name" content="Comunicación Magnética" data-id="element-455" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-456" />
      <meta name="twitter:url" content={siteUrl} data-id="element-457" />
      <meta name="twitter:title" content={siteTitle} data-id="element-458" />
      <meta name="twitter:description" content={siteDescription} data-id="element-459" />
      <meta name="twitter:image" content={siteImage} data-id="element-460" />
      {/* Search Engine Verification Tags (Placeholders - user would add actual IDs) */}
      <meta name="google-site-verification" content="" data-id="element-461" />
      <meta name="yandex-verification" content="" data-id="element-462" />
      <meta name="msvalidate.01" content="" data-id="element-463" /> {/* Bing */}
      <meta name="baidu-site-verification" content="" data-id="element-464" />
      {/* Structured Data */}
      <script type="application/ld+json" data-id="element-465">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>;
}